import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-message-board-item',
  templateUrl: './message-board-item.component.html',
  styleUrls: ['./message-board-item.component.scss']
})
export class MessageBoardItemComponent implements OnInit {
  @Input() message: any = {};

  constructor() { }

  ngOnInit() {
  }

}
